import React from "react";
import { useTheme } from "../../Hooks";
import useStyles from "./FmFooter.style";
import { FmIcon } from "..";
import { useTranslation } from "react-i18next";
import { links } from "../../Utils/Consts";

interface FmFooterProps {
  setShowTerms?: any;
  setShowPrivacy?: any;
}

const FmFooter = ({ setShowTerms, setShowPrivacy }: FmFooterProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.icons_container}>
        <a href={links.haifaFacebook} target="_blank" rel="noreferrer noopener" className={classes.link}>
          <FmIcon url={theme.images.facebook} className={classes.facebookIcon} />
        </a>
        <a href={links.haifaLinkedIn} target="_blank" rel="noreferrer noopener" className={classes.link}>
          <FmIcon url={theme.images.linkedin} className={classes.linkedinIcon} />
        </a>
      </div>
      <div className={classes.secondRow}>
        <span className={classes.terms_privacy_text} onClick={() => setShowTerms(true)}>
          {t("sideMenu.termsAndCondition.title")}
        </span>
        <span className={classes.line}>|</span>
        <span className={classes.terms_privacy_text} onClick={() => setShowPrivacy(true)}>
          {t("sideMenu.privacyPolicy.title")}
        </span>
      </div>
      <span className={classes.copyright}>&copy; {t("sideMenu.copyRightTitle")}</span>
      <div className={classes.zigit}>
        <span>{t("sideMenu.poweredBy")}</span>
        <a href={links.zigitWebsite} target="_blank" rel="noreferrer noopener">
          <FmIcon url={theme.images.zigit} className={classes.zigitIcon_container} />
        </a>
      </div>
    </div>
  );
};

export default FmFooter;
